import SectionEyebrow from "./SectionEyebrow";
import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/useLanguage";
import { getServiceDetailT } from "@/i18n/serviceDetail";

interface Props {
  title: string;
  content: string;
  image?: string;
  color?: string;
  /** Opt-in unified eyebrow (replaces the default label). */
  eyebrow?: string;
  eyebrowAccent?: string;
}

const ServiceChallenges = ({ title, content, image, color, eyebrow, eyebrowAccent }: Props) => {
  const lang = useLanguage();
  const t = getServiceDetailT(lang);

  if (!content) return null;

  const paragraphs = content.split("\n\n");

  return (
    <section className="py-10 sm:py-14">
      <div className="container mx-auto px-6 lg:px-10 max-w-5xl">
        {eyebrow ? <SectionEyebrow accent={eyebrowAccent}>{eyebrow}</SectionEyebrow> : <div className="flex items-center gap-3 mb-2">
          {color && <span className="w-6 h-0.5 rounded-full" style={{ backgroundColor: color }} />}
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t.industryContext}</p>
        </div>}
        <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-6">{title}</h2>
        <div className="space-y-3">
          {paragraphs.map((p, i) => (
            <p
              key={i}
              className="text-sm text-muted-foreground leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: p.replace(
                  /\*\*(.*?)\*\*/g,
                  '<strong class="text-foreground font-medium">$1</strong>'
                ),
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceChallenges;
